import { faExchangeAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction, useState } from "react";
import ModalComponent from "../../../../Components/Modais";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import { useHistoricoContext } from "../../../../Context/Historico";
import UnForm from "../../../../Components/Form";
import { ListarUsuariosPorEquipeVendasController } from "../../../../Controllers/Vendas/Usuario/UsuarioController";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { TransferirLeadsEmMassaController } from "../../../../Controllers/Vendas/Lead/LeadController";
import { ITransferirLeadsEmMassa } from "../../../../Interfaces/Vendas/Lead/LeadInterface";
import { ListarEquipeDeVendasController } from "../../../../Controllers/Vendas/EquipeVendas/EquipeVendasControllers";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import Swal from "sweetalert2";

interface ITransferirOportunidadesEmMassa {
    setShow: Dispatch<SetStateAction<boolean>>;
    updateList: () => void;
    filter: any;
    idEmpreendimento: string | undefined;
}

export default function TransferirOportunidadesEmMassa(
    props: ITransferirOportunidadesEmMassa
) {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    return (
        <>
            <ul className="sticky-toolbar nav flex-column pl-2 pr-2 pt-3 pb-3 mt-40">
                <li
                    className="nav-item"
                    data-toggle="tooltip"
                    title="Transferir Oportunidades em massa"
                    data-placement="left"
                    data-original-title="Transferir oportunidades"
                >
                    <button
                        className="btn btn-sm btn-icon btn-bg-light btn-icon-info btn-hover-success"
                        onClick={() => {
                            setShow(true);
                            setModal({
                                Component: () => (
                                    <TransferirLeadsEmMassaComponent
                                        {...props}
                                        setShow={setShow}
                                    />
                                ),
                                IconHeader: faExchangeAlt,
                                headerComponent:
                                    "Transferir Oportunidades em Massa",
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faExchangeAlt} />
                    </button>
                </li>
            </ul>

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}

function TransferirLeadsEmMassaComponent(
    props: ITransferirOportunidadesEmMassa
) {
    const { ReloadHistorico } = useHistoricoContext();

    const [equipes, setEquipes] = useState("");

    const {
        loading: ListarUsuariosPorEquipeVendasLoading,
        value: usuariosPorEquipeVendas,
    } = useAsyncEffect(async () => {
        if (equipes)
            return ListarUsuariosPorEquipeVendasController(Number(equipes));
    }, [equipes]);

    const {
        execute: TransferirLeadsEmMassa,
        loading: TransferirLeadsEmMassaLoading,
    } = useAsyncCallback(TransferirLeadsEmMassaController);

    function handleTransferirFormSubmit(formData: ITransferirLeadsEmMassa) {
        Swal.fire({
            title: "Transferir Leads",
            text: `Deseja realmente transferir as oportunidades para ${
                usuariosPorEquipeVendas?.find(
                    (u) =>
                        u.ID_USUARIO === Number(formData.ID_RESPONSAVEL_DESTINO)
                )?.DS_NOME
            }?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "<i class='la la-check'></i> Sim!",
            cancelButtonText: "<i class='la la-thumbs-down'></i> Não",
            customClass: {
                confirmButton: "btn btn-success",
                cancelButton: "btn btn-default",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                TransferirLeadsEmMassa(formData.ID_RESPONSAVEL_DESTINO, {
                    NR_PAGINA: props.filter.page,
                    NR_QUANTIDADE: 10,
                    DS_PESQUISA: props.filter.filter.DS_PESQUISA
                        ? props.filter.filter.DS_PESQUISA
                        : "",
                    DS_EMAIL: props.filter.filter.DS_EMAIL
                        ? props.filter.filter.DS_EMAIL
                        : "",
                    DS_NOME_CONTA: props.filter.filter.DS_NOME_CONTA
                        ? props.filter.filter.DS_NOME_CONTA
                        : "",
                    DS_SITUACAO: props.filter.filter.DS_SITUACAO
                        ? props.filter.filter.DS_SITUACAO
                        : "",
                    DT_FIM: props.filter.filter.DT_FIM
                        ? props.filter.filter.DT_FIM
                        : undefined,
                    DT_INICIO: props.filter.filter.DT_INICIO
                        ? props.filter.filter.DT_INICIO
                        : undefined,
                    FL_ASSINATURA_CONCLUIDA: props.filter
                        .FL_ASSINATURA_CONCLUIDA
                        ? props.filter.filter.FL_ASSINATURA_CONCLUIDA
                        : undefined,
                    FL_ENVELOPE_ENVIADO: props.filter.filter.FL_ENVELOPE_ENVIADO
                        ? props.filter.filter.FL_ENVELOPE_ENVIADO
                        : undefined,
                    ID_CASO: props.filter.filter.ID_CASO
                        ? props.filter.filter.ID_CASO
                        : 0,
                    ID_CONTRATO_STATUS: props.filter.filter.ID_CONTRATO_STATUS
                        ? props.filter.filter.ID_CONTRATO_STATUS
                        : 0,
                    ID_EQUIPE_VENDAS: props.filter.filter.ID_EQUIPE_VENDAS
                        ? props.filter.filter.ID_EQUIPE_VENDAS
                        : "",
                    FILTRO_DATA: props.filter.filter.FILTRO_DATA
                        ? props.filter.filter.FILTRO_DATA
                        : 1,
                    ID_ETAPA_TIPO_CASO: props.filter.filter.ID_ETAPA_TIPO_CASO
                        ? props.filter.filter.ID_ETAPA_TIPO_CASO
                        : 0,
                    ID_ORIGEM_LEAD: props.filter.filter.ID_ORIGEM_LEAD
                        ? props.filter.filter.ID_ORIGEM_LEAD
                        : "",
                    ID_PRODUTO: props.idEmpreendimento
                        ? props.idEmpreendimento
                        : "",
                    ID_USUARIO_CADASTRO: props.filter.filter.ID_USUARIO_CADASTRO
                        ? props.filter.filter.ID_USUARIO_CADASTRO
                        : 0,
                    ID_USUARIO_RESPONSAVEL: props.filter.filter
                        .ID_USUARIO_RESPONSAVEL
                        ? props.filter.filter.ID_USUARIO_RESPONSAVEL
                        : 0,
                    NR_CPF: props.filter.filter.NR_CPF
                        ? props.filter.filter.NR_CPF
                        : "",
                    NR_DIAS_ESTAGNADO_MAX: props.filter.filter
                        .NR_DIAS_ESTAGNADO_MAX
                        ? props.filter.filter.NR_DIAS_ESTAGNADO_MAX
                        : 0,
                    NR_DIAS_ESTAGNADO_MIN: props.filter.filter
                        .NR_DIAS_ESTAGNADO_MIN
                        ? props.filter.filter.NR_DIAS_ESTAGNADO_MIN
                        : 0,
                    NR_OPORTUNIDADE: props.filter.filter.NR_OPORTUNIDADE
                        ? props.filter.filter.NR_OPORTUNIDADE
                        : 0,
                    NR_TELEFONE: props.filter.filter.NR_TELEFONE
                        ? props.filter.filter.NR_TELEFONE
                        : "",
                    DT_VENCIMENTO_FN: props.filter.filter.DT_VENCIMENTO_FN
                        ? Number(props.filter.filter.DT_VENCIMENTO_FN)
                        : undefined,
                    DT_VENCIMENTO_IN: props.filter.filter.DT_VENCIMENTO_IN
                        ? Number(props.filter.filter.DT_VENCIMENTO_IN)
                        : undefined,
                    FL_VENCIDO:
                        props.filter.filter.FL_VENCIDO === "Sim"
                            ? true
                            : props.filter.filter.FL_VENCIDO === "Não"
                            ? false
                            : undefined,
                }).then(() => {
                    props.updateList();
                    props.setShow(false);
                    if (ReloadHistorico) ReloadHistorico();
                });
            }
        });
    }

    return (
        <UnForm handleSubmit={handleTransferirFormSubmit}>
            <div className="form-group">
                <label htmlFor="ID_EQUIPE_VENDAS">Equipe de Vendas</label>
                <UnForm.LazySelect
                    name="ID_EQUIPE_VENDAS"
                    className="form-control mb-2"
                    controller={ListarEquipeDeVendasController}
                    getDS={(equipe) => equipe.DS_EQUIPE_VENDAS}
                    getKeyValue={(equipe) => equipe.ID_EQUIPE_VENDAS}
                    registerOptions={{
                        required: "Selecione uma equipe",
                    }}
                    onChange={(e) => {
                        setEquipes(e.target.value);
                    }}
                >
                    <option></option>
                </UnForm.LazySelect>
                {ListarUsuariosPorEquipeVendasLoading ? (
                    <div className="d-flex justify-content-center align-items-center">
                        <Spinner size="sm" color="primary" />
                    </div>
                ) : (
                    <>
                        {usuariosPorEquipeVendas &&
                            usuariosPorEquipeVendas?.length > 0 && (
                                <>
                                    <label htmlFor="ID_RESPONSAVEL_DESTINO">
                                        Corretor Destino
                                    </label>
                                    <UnForm.Select
                                        name="ID_RESPONSAVEL_DESTINO"
                                        className="form-control"
                                        registerOptions={{
                                            required: "Selecione um corretor",
                                        }}
                                    >
                                        <option></option>
                                        {usuariosPorEquipeVendas.map(
                                            (usuario) => (
                                                <option
                                                    key={usuario.ID_USUARIO}
                                                    value={usuario.ID_USUARIO}
                                                >
                                                    {usuario.DS_NOME}
                                                </option>
                                            )
                                        )}
                                    </UnForm.Select>
                                </>
                            )}
                    </>
                )}

                {usuariosPorEquipeVendas?.length === 0 && (
                    <div className="text-info text-center mt-2">
                        Não existe corretor para essa equipe de vendas.
                    </div>
                )}
            </div>

            <button
                className="btn btn-success col-12"
                type="submit"
                disabled={TransferirLeadsEmMassaLoading}
            >
                {TransferirLeadsEmMassaLoading ? (
                    <Spinner color="primary" size="sm" />
                ) : (
                    <>
                        <FontAwesomeIcon icon={faExchangeAlt} /> Transferir
                    </>
                )}
            </button>
        </UnForm>
    );
}
